import {authenticated_api} from "./base";
import { getDevCreditsBalancePayload } from "../helper/devCreditsBalance";

export const getCreditsBalance = async () => {
  try {
    return await authenticated_api.get(`/credits/balance/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    const devFallback = getDevCreditsBalancePayload();
    if (devFallback) {
      return { status: 200, data: devFallback };
    }
    return error.response;
  }
};

export const getCreditPackages = async () => {
  try {
    return await authenticated_api.get(`/credits/packages/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const createCheckoutSession = async (package_id) => {
  try {
    return await authenticated_api.post(`/credits/checkout/`, {package_id});
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getCreditsHistory = async () => {
  try {
    return await authenticated_api.get(`/credits/history/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};
